function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function main() {
  return import(/* webpackChunkName: "page-main" */ '@/pages/main.vue')
}
function test() {
  return import(/* webpackChunkName: "page-test" */ '@/pages/test.vue')
}
function company_p_company005() {
  return import(
    /* webpackChunkName: "page-company-p_company005" */ '@/pages/company/p_company005.vue'
  )
}
function company_p_company006() {
  return import(
    /* webpackChunkName: "page-company-p_company006" */ '@/pages/company/p_company006.vue'
  )
}
function company_p_company009() {
  return import(
    /* webpackChunkName: "page-company-p_company009" */ '@/pages/company/p_company009.vue'
  )
}
function company_p_company010() {
  return import(
    /* webpackChunkName: "page-company-p_company010" */ '@/pages/company/p_company010.vue'
  )
}
function company_p_company011() {
  return import(
    /* webpackChunkName: "page-company-p_company011" */ '@/pages/company/p_company011.vue'
  )
}
function esg_p_esg022() {
  return import(
    /* webpackChunkName: "page-esg-p_esg022" */ '@/pages/esg/p_esg022.vue'
  )
}
function esg_p_esg023() {
  return import(
    /* webpackChunkName: "page-esg-p_esg023" */ '@/pages/esg/p_esg023.vue'
  )
}
function esg_p_esg024() {
  return import(
    /* webpackChunkName: "page-esg-p_esg024" */ '@/pages/esg/p_esg024.vue'
  )
}
function esg_p_esg025() {
  return import(
    /* webpackChunkName: "page-esg-p_esg025" */ '@/pages/esg/p_esg025.vue'
  )
}
function esg_p_esg026() {
  return import(
    /* webpackChunkName: "page-esg-p_esg026" */ '@/pages/esg/p_esg026.vue'
  )
}
function footer_p_footer032() {
  return import(
    /* webpackChunkName: "page-footer-p_footer032" */ '@/pages/footer/p_footer032.vue'
  )
}
function footer_p_footer037() {
  return import(
    /* webpackChunkName: "page-footer-p_footer037" */ '@/pages/footer/p_footer037.vue'
  )
}
function invest_p_invest018() {
  return import(
    /* webpackChunkName: "page-invest-p_invest018" */ '@/pages/invest/p_invest018.vue'
  )
}
function invest_p_invest019() {
  return import(
    /* webpackChunkName: "page-invest-p_invest019" */ '@/pages/invest/p_invest019.vue'
  )
}
function invest_p_invest020() {
  return import(
    /* webpackChunkName: "page-invest-p_invest020" */ '@/pages/invest/p_invest020.vue'
  )
}
function invest_p_invest021() {
  return import(
    /* webpackChunkName: "page-invest-p_invest021" */ '@/pages/invest/p_invest021.vue'
  )
}
function recruit_p_recruit026() {
  return import(
    /* webpackChunkName: "page-recruit-p_recruit026" */ '@/pages/recruit/p_recruit026.vue'
  )
}
function recruit_p_recruit027() {
  return import(
    /* webpackChunkName: "page-recruit-p_recruit027" */ '@/pages/recruit/p_recruit027.vue'
  )
}
function recruit_p_recruit028() {
  return import(
    /* webpackChunkName: "page-recruit-p_recruit028" */ '@/pages/recruit/p_recruit028.vue'
  )
}
function tech_p_tech012() {
  return import(
    /* webpackChunkName: "page-tech-p_tech012" */ '@/pages/tech/p_tech012.vue'
  )
}
function tech_p_tech017() {
  return import(
    /* webpackChunkName: "page-tech-p_tech017" */ '@/pages/tech/p_tech017.vue'
  )
}
function tech_p_tech034() {
  return import(
    /* webpackChunkName: "page-tech-p_tech034" */ '@/pages/tech/p_tech034.vue'
  )
}
function tech_p_tech035() {
  return import(
    /* webpackChunkName: "page-tech-p_tech035" */ '@/pages/tech/p_tech035.vue'
  )
}
function recruit__FaqList() {
  return import(
    /* webpackChunkName: "page-recruit-FaqList" */ '@/pages/recruit/_FaqList.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
  },
  {
    name: 'main',
    path: 'main',
    component: main,
  },
  {
    name: 'test',
    path: 'test',
    component: test,
  },
  {
    name: 'company-p_company005',
    path: 'company/p_company005',
    component: company_p_company005,
  },
  {
    name: 'company-p_company006',
    path: 'company/p_company006',
    component: company_p_company006,
  },
  {
    name: 'company-p_company009',
    path: 'company/p_company009',
    component: company_p_company009,
  },
  {
    name: 'company-p_company010',
    path: 'company/p_company010',
    component: company_p_company010,
  },
  {
    name: 'company-p_company011',
    path: 'company/p_company011',
    component: company_p_company011,
  },
  {
    name: 'esg-p_esg022',
    path: 'esg/p_esg022',
    component: esg_p_esg022,
  },
  {
    name: 'esg-p_esg023',
    path: 'esg/p_esg023',
    component: esg_p_esg023,
  },
  {
    name: 'esg-p_esg024',
    path: 'esg/p_esg024',
    component: esg_p_esg024,
  },
  {
    name: 'esg-p_esg025',
    path: 'esg/p_esg025',
    component: esg_p_esg025,
  },
  {
    name: 'esg-p_esg026',
    path: 'esg/p_esg026',
    component: esg_p_esg026,
  },
  {
    name: 'footer-p_footer032',
    path: 'footer/p_footer032',
    component: footer_p_footer032,
  },
  {
    name: 'footer-p_footer037',
    path: 'footer/p_footer037',
    component: footer_p_footer037,
  },
  {
    name: 'invest-p_invest018',
    path: 'invest/p_invest018',
    component: invest_p_invest018,
  },
  {
    name: 'invest-p_invest019',
    path: 'invest/p_invest019',
    component: invest_p_invest019,
  },
  {
    name: 'invest-p_invest020',
    path: 'invest/p_invest020',
    component: invest_p_invest020,
  },
  {
    name: 'invest-p_invest021',
    path: 'invest/p_invest021',
    component: invest_p_invest021,
  },
  {
    name: 'recruit-p_recruit026',
    path: 'recruit/p_recruit026',
    component: recruit_p_recruit026,
  },
  {
    name: 'recruit-p_recruit027',
    path: 'recruit/p_recruit027',
    component: recruit_p_recruit027,
  },
  {
    name: 'recruit-p_recruit028',
    path: 'recruit/p_recruit028',
    component: recruit_p_recruit028,
  },
  {
    name: 'tech-p_tech012',
    path: 'tech/p_tech012',
    component: tech_p_tech012,
  },
  {
    name: 'tech-p_tech017',
    path: 'tech/p_tech017',
    component: tech_p_tech017,
  },
  {
    name: 'tech-p_tech034',
    path: 'tech/p_tech034',
    component: tech_p_tech034,
  },
  {
    name: 'tech-p_tech035',
    path: 'tech/p_tech035',
    component: tech_p_tech035,
  },
  {
    name: 'recruit-FaqList',
    path: 'recruit/:FaqList?',
    component: recruit__FaqList,
  },
]
